function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#hahaicon .cls-1{fill:#fcd226;}#hahaicon .cls-2{fill:#fdeb4e;}#hahaicon .cls-3{fill:#f7b722;}#hahaicon .cls-4{fill:#88271f;}#hahaicon .cls-5{fill:#e85a50;}#hahaicon .cls-6{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,14S.49,8.21,3.55,5.28,9.56.4,15.76,0,25.83,5.91,26.43,7s2.38,4.44,2.38,7,0,8-3.65,10.38-7.2,3.8-9.74,3.67-8.93-.67-11.8-4.67S0,18.14,0,14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M14.91,3a5.14,5.14,0,0,1,3.91.45.18.18,0,0,0,.25-.24c-.55-1-2-2.83-4.32-.51A.17.17,0,0,0,14.91,3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M9.14,25.43c-1.5-1.55-3.5-3.5-3.3-10.2S7.64,6.16,8.79,4.38A15.15,15.15,0,0,1,14.24.15,16.51,16.51,0,0,0,3.55,5.28C.49,8.21,0,14,0,14c0,4.09.75,5.37,3.62,9.38s9.27,4.53,11.8,4.66C15.42,28.08,10.64,27,9.14,25.43Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mouth",
  className: "cls-4",
  d: "M15.83,23.89s8,.14,9.42-7.35a1,1,0,0,0-.88-1.21,77.18,77.18,0,0,0-17.92.27,1,1,0,0,0-.85,1.18C6,18.87,7.75,23.39,15.83,23.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M16.7,23.33s-4.89.37-6.94-1.68l.25-.18a3.7,3.7,0,0,1,.84-.37,7,7,0,0,1,1.57-.25c.32,0,.63,0,.94,0a3.43,3.43,0,0,1,1,.14,4.15,4.15,0,0,1,.89.39,3.5,3.5,0,0,1,1.09.9A2.06,2.06,0,0,1,16.7,23.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M8.39,15.82s7-.44,14.83-.27c0,0-.4,1.57-7.63,1.57C14,17.12,8.69,17.75,8.39,15.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M8.26,8.87A8,8,0,0,1,10.07,10a.21.21,0,0,1-.14.37c-1,0-3.15.05-4.33,1.45a.11.11,0,0,0,.12.18,14.42,14.42,0,0,1,6.57-.27.32.32,0,0,0,.36-.41c-.3-.93-1.27-2.83-4.35-2.63A.09.09,0,0,0,8.26,8.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M22.16,8.89a6.86,6.86,0,0,0-1.57,1,.18.18,0,0,0,.12.32,4.73,4.73,0,0,1,3.74,1.26.1.1,0,0,1-.1.16,12.48,12.48,0,0,0-5.68-.26.27.27,0,0,1-.31-.35c.25-.8,1.11-2.44,3.77-2.26C22.21,8.75,22.24,8.86,22.16,8.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M8.34,8.47A8.25,8.25,0,0,1,10.16,9.6.21.21,0,0,1,10,10c-1,0-3.15,0-4.33,1.45a.11.11,0,0,0,.12.18,14.42,14.42,0,0,1,6.57-.27.32.32,0,0,0,.36-.41c-.29-.93-1.27-2.83-4.35-2.63A.09.09,0,0,0,8.34,8.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M22.24,8.49a7.08,7.08,0,0,0-1.57,1,.18.18,0,0,0,.13.32,4.72,4.72,0,0,1,3.73,1.26.1.1,0,0,1-.1.16A12.46,12.46,0,0,0,18.75,11a.27.27,0,0,1-.31-.35,3.33,3.33,0,0,1,3.77-2.26C22.29,8.35,22.32,8.46,22.24,8.49Z"
})));

var SvgHaha = function SvgHaha(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hahaicon",
    viewBox: "0 0 28.81 28.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHaha, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/haha.c858fadb.svg";
export { ForwardRef as ReactComponent };